<script>
  import { createEventDispatcher, onMount } from 'svelte';

  const dispatch = createEventDispatcher();
  export let logoURL = "/assets/images/logos/logo.svg";
  export let brandName = "Curbza";
  export let links = [
    {
      id: 1,
      label: "Clients",
      href: "#clients",
    },
    {
      id: 2,
      label: "Why Curbza",
      href: "#why-curbza",
    },
    // {
    //   id: 3,
    //   label: "Case Studies",
    //   href: "#case-studies",
    // },
    {
      id: 4,
      label: "Enterprise",
      href: "#enterprise",
    },
    {
      id: 5,
      label: "Pricing",
      href: "#pricing-plans",
    },
    {
      id: 6,
      label: "About Us",
      href: "#about-us",
    },
    {
      id: 7,
      label: "Blog",
      href: "//blog.curbza.com",
    },
  ];
  let activeLink;
  let tabletNav;

  onMount(() => {
    tabletNav = document.querySelector('.tablet-nav');
  });

  export const onContact = () => {
    navExpanded = false;
    dispatch('contact')
  };

  const onLiveDemo = () => {
    navExpanded = false;
    dispatch('livedemo')
  };

  const onRequestADemo = () => {
    navExpanded = false;
    dispatch('requestademo')
  };

  const onDismissMobileNav = (link) => {
    navExpanded = false;
    if (link.href.startsWith('#')) {
      scrollToSection(link);
    } else {
      location.assign(link.href);
    }
  }

  let timer;

  const scrollToSection = (link) => {
    activeLink = link;
    const elem = document.querySelector(link.href);
    if (elem) {
      scrollTo(0, elem.offsetTop);
    } else {
      // Wait a bit then scroll
      clearTimeout(timer);
      timer = setTimeout(() => {
        scrollTo(0, document.querySelector(link.href.offsetTop));
      }, 1000);
    }
  }

  let navExpanded = false;
  let tabletNavExpanded = false;

  const toggleNav = () => {
    navExpanded = !navExpanded;
  }

  const toggleTabletMenu = () => {
    tabletNavExpanded = !tabletNavExpanded;
    document.querySelector('.tablet-nav').classList.toggle('collapsed');
  }
</script>

<style>
  .navbar {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: var(--navbar-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--light);
    color: var(--primary);
    padding: var(--page-padding);
    border-bottom: 2px solid var(--panel-dark);
    z-index: 1;
  }

  .navbar > .navbar-brand > a > img {
    height: 48px;
  }

  /* Navbar nav */
  .navbar-nav {
    display: flex;
    padding: 0;
    list-style-type: none;
  }

  .navbar-nav li a {
    font-family: 'Open Sans Bold', Arial, Helvetica, sans-serif;
    font-size: 20px;
    line-height: 27px;
    font-weight: 500;
    padding: 8px 16px;
    text-decoration: none;
    transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    color: var(--primary);
  }

  .navbar-nav li a:hover {
    color: var(--primary-dark);
  }

  .navbar-nav li a.link-secondary {
    color: var(--secondary);
  }

  .navbar-nav li a.link-secondary:hover {
    color: var(--secondary-dark);
  }

  /* Navbar actions */
  .navbar .navbar-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .navbar .navbar-actions button {
    font-family: 'Roboto Bold', Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 0;
    box-shadow: 0px 2px 10px -6px rgba(0, 0, 0, 0.6);
  }

  .navbar .navbar-actions button:not(:last-child) {
    margin-right: 1vw;
  }

  .navbar .navbar-actions button:hover {
    box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.8);
  }

  .navbar .btn-toggle-nav-mobile {
    display: none;
  }

  /* Tablet */
  .navbar .navbar-nav.tablet-nav {
    position: fixed;
    background-color: var(--light);
    width: var(--navbar-tablet-width);
    top: var(--navbar-height);
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    padding-top: 16px;
    transition: all .3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .navbar .navbar-nav.tablet-nav.collapsed {
    right: -250px;
  }
  
  .navbar .navbar-nav.tablet-nav li {
    padding: 8px 16px;
  }

  /* Mobile */
  .mobile-nav {
    display: none;
  }

  .mobile-nav {
    display: none;
    flex-direction: column;
    padding: 2vw;
    justify-content: flex-start;
    position: fixed;
    top: var(--navbar-height);
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 1;
  }

  .mobile-nav .mobile-nav-list-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    margin-bottom: 1vw;
    border: 1px solid var(--primary);
    border-radius: 4px;
    transition: all .3s linear;
  }

  .mobile-nav .mobile-nav-list-item:hover {
    background-color: var(--primary);
    cursor: pointer;
  }

  .mobile-nav .mobile-nav-list-item a {
    text-decoration: none;
  }

  .mobile-nav .mobile-nav-list-item:hover a {
    color: var(--primary-text);
  }

  .navbar .btn-toggle-nav-mobile {
    display: none;
  }

  /* Small devices (landscape phones, 767px and below) */
  @media only screen and (max-width: 767px) {
    .navbar .navbar-nav,
    .navbar .navbar-actions {
      display: none;
    }

    .navbar .btn-toggle-nav-mobile {
      display: block;
    }

    .navbar .btn-toggle-nav-tablet {
      display: none;
    }

    .mobile-nav {
      display: flex;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .navbar-nav li a {
      font-size: large;
    }

    .navbar .btn-toggle-nav-tablet {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 1vw;
      margin-bottom: 0;
    }

    .navbar .btn-toggle-nav-tablet button {
      line-height: 20px;
      margin-bottom: 0;
    }

    .navbar .btn-toggle-nav-mobile {
      display: none;
    }

    .navbar .navbar-actions button {
      font-size: small;
      line-height: 20px;
    }

    .navbar .navbar-nav.desktop-nav {
      display: none;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media only screen and (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .navbar-nav li a {
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
    }
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media only screen and (min-width: 1400px) {
    .navbar .navbar-actions button {
      font-size: 14px;
      line-height: 20px;
    }

    .navbar .btn-toggle-nav-tablet {
      display: none;
    }

    .navbar .navbar-spacer {
      display: none;
    }

    .navbar .navbar-nav.desktop-nav {
      display: flex;
    }
  }
</style>

<main id="navbar-main">
  <nav class="navbar">
    <div class="navbar-brand">
      <a href="/" title={brandName}> <img src={logoURL} alt={brandName} /> </a>
    </div>
    <span class="spacer navbar-spacer"></span>
    <ul class="navbar-nav nav-links desktop-nav">
      {#each links as link (link.id)}
        {#if link.href.startsWith('#')}
          <li><a href="/" on:click={() => scrollToSection(link)}>{link.label}</a></li>
        {:else}
          <li><a href={link.href} class="link-secondary">{link.label}</a></li>
        {/if}
      {/each}
    </ul>
    <span class="navbar-actions">
      <button on:click={onContact}>Contact</button>
      <!-- <button class="btn-secondary" on:click={onLiveDemo}>Live Demo</button> -->
      <button class="btn-accent" on:click={onRequestADemo}>Request a Demo</button>
    </span>
    <ul class="navbar-nav nav-links tablet-nav collapsed">
      {#each links as link (link.id)}
        {#if link.href.startsWith('#')}
          <li><a href="/" on:click={() => scrollToSection(link)}>{link.label}</a></li>
        {:else}
          <li><a href={link.href} class="link-secondary">{link.label}</a></li>
        {/if}
      {/each}
    </ul>
    <span class="btn-toggle-nav-tablet">
      <button on:click={toggleTabletMenu}>
        <i class="fas fa-bars"></i>
      </button>
    </span>

    <span class="btn-toggle-nav-mobile">
      <button on:click={toggleNav}>
        <i class="fas fa-bars"></i>
      </button>
    </span>
  </nav>
  {#if navExpanded}
  <div class="mobile-nav">
    {#each links as link (link.id)}
      {#if link.href.startsWith('#')}
        <div
          class="mobile-nav-list-item"
          on:click={() => onDismissMobileNav(link)}>
          <a href="/" on:click={() => scrollToSection(link)}>{link.label}</a>
        </div>
      {:else}
        <div
          class="mobile-nav-list-item"
          on:click={() => onDismissMobileNav(link)}>
          <a href={link.href} class="link-secondary">{link.label}</a>
        </div>
      {/if}
    {/each}
    <button on:click={onContact}>Contact</button>
    <!-- <button class="btn-secondary" on:click={onLiveDemo}>Live Demo</button> -->
    <button class="btn-accent" on:click={onRequestADemo}>Request a Demo</button>
  </div>    
  {/if}
</main>
